module.exports = __webpack_public_path__ + "static/media/IncreasingPositiveAttitude.5f2480ee.mp3";